var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { constants } from "../../constants";
var BrazeHttpService = /** @class */ (function () {
    function BrazeHttpService() {
        Object.defineProperty(this, "baseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "https://rest.fra-01.braze.eu"
        });
    }
    Object.defineProperty(BrazeHttpService, "getInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.instance) {
                this.instance = new BrazeHttpService();
            }
            return this.instance;
        }
    });
    Object.defineProperty(BrazeHttpService.prototype, "newAlias", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (_a) {
            var alias = _a.alias;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, fetch("".concat(this.baseUrl, "/users/alias/new"), {
                                method: "post",
                                headers: {
                                    "content-type": "application/json",
                                    Authorization: "Bearer " + constants.BRAZE_API_KEY,
                                },
                                body: JSON.stringify({
                                    user_aliases: [this.userAliasObject(alias)],
                                }),
                            })];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(BrazeHttpService.prototype, "identify", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (_a) {
            var userId = _a.userId, alias = _a.alias;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, fetch("".concat(this.baseUrl, "/users/identify"), {
                                method: "post",
                                headers: {
                                    "content-type": "application/json",
                                    Authorization: "Bearer " + constants.BRAZE_API_KEY,
                                },
                                body: JSON.stringify({
                                    aliases_to_identify: [
                                        {
                                            external_id: userId,
                                            user_alias: this.userAliasObject(alias),
                                        },
                                    ],
                                    merge_behavior: "merge",
                                }),
                            })];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(BrazeHttpService.prototype, "track", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (_a) {
            var alias = _a.alias, event = _a.event, externalId = _a.externalId, properties = _a.properties;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, fetch("".concat(this.baseUrl, "/users/track"), {
                                method: "post",
                                headers: {
                                    "content-type": "application/json",
                                    Authorization: "Bearer " + constants.BRAZE_API_KEY,
                                },
                                body: JSON.stringify({
                                    events: [
                                        {
                                            name: event,
                                            time: new Date().toISOString(),
                                            user_alias: this.userAliasObject(alias),
                                            external_id: externalId,
                                            properties: properties,
                                        },
                                    ],
                                }),
                            })];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(BrazeHttpService.prototype, "userAliasObject", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (userAlias) {
            return {
                alias_name: userAlias,
                alias_label: "chrome_extension_user",
            };
        }
    });
    return BrazeHttpService;
}());
export { BrazeHttpService };
